@if ((vehicles() | keyvalue).length) {
	<div class="timeline-container">
		@for (vehicle of vehicles() | keyvalue; track vehicle.key) {
			<div class="row">
				<div class="col">
					<h6 class="timeline-header">{{ vehicle.key }}</h6>
					<div class="timeline-steps">
						@for (stop of vehicle.value; track stop.id) {
							<div class="timeline-step">
								<div class="timeline-content">
									<div
										[ngClass]="{
											'red-circle': stop.action === StopKind.BOARDING,
											'green-circle': stop.action === StopKind.DROP_OFF,
											'blue-circle': stop.action === StopKind.CRUISING,
											'yellow-circle': stop.action === AdvancedStopKind.ADVANCED,
										}"
										class="inner-circle"
									></div>
									<p class="h6 mb-1">{{ stop.name }}</p>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		}
	</div>
	<app-legend></app-legend>
}
